import React from 'react'
import { Link } from 'react-router-dom'
import { GetNavigations } from '../Functions/functions'

const Footer = () => {
    return (
        <div className='privacyAndCookieBottom'>
            <Link to={GetNavigations("/privacy")} target="_blank">Privacy Policy</Link>
            <Link to={GetNavigations("/cookie")} target="_blank" className="cookiePolicy">Cookie Policy</Link>
        </div>
    )
}

export default Footer